export default __webpack_public_path__ + "static/media/Finance.cab01d43.png";